<template>
    <section class="hashtag-section _edit-section">
        <div class="section-inner">
            <h2 class="heading-section"><span>Hashtags</span></h2>
            <div class="hashtag-item-wrap">

                <template v-for="(hashtag, index) in $store.state.register.form.hashtag" v-bind:key="index">
                    <input type="checkbox" :name="hashtag + (index+1)" :id="hashtag + (index+1)">
                    <label :for="hashtag + (index+1)" class="btn_common _edit">
                        <div class="md_svg-icon">
                            <SvgIconHashTag />
                        </div>
                        <span>{{ hashtag }}</span>
                        <div class="number" v-if="hashtag.count"><span>{{hashtag.count}}</span></div>
                        <div class="close-icon" v-on:click="deleteHashtag(index)"></div>
                    </label>
                </template>

                <div class="add-hashtag">
                    <div class="input">
                        <input type="text" maxlength="250" class="edit-pen" placeholder="追加ハッシュタグを入力" v-model="hashtag">
                    </div>
                    <button type="button" class="btn" v-on:click="addHashtag()">
                        <div class="md_icon-btn _stroke-white">
                            <div class="inner"><SvgIconEnter /></div>
                        </div>
                    </button>
                </div>

            </div>
        </div><!--/.section-inner-->
    </section>
</template>

<script>
    import SvgIconHashTag from '@/components/EndUser/svg/SvgIconHashTag'
    import SvgIconEnter from '@/components/EndUser/svg/SvgIconEnter'

    export default {
        components: {
            SvgIconEnter,
            SvgIconHashTag,
        },
        data() {
            return {
                hashtag: '',
            }
        },
        mounted() {
            // 編集の場合
            if (this.$store.state.detail.set.brand.hashtags) {
                for(var i in this.$store.state.detail.set.brand.hashtags) {
                    var hashtag = this.$store.state.detail.set.brand.hashtags[i];
                    this.$store.state.register.form.hashtag.push(hashtag.name)
                }
            }
        },
        methods: {
            addHashtag: function() {
                var itemIndex = '';
                var itemCheck = true;
                var self = this;

                this.$store.state.register.form.hashtag.forEach(function(item, index){
                    if (item == self.hashtag) {
                        itemIndex = index;
                        itemCheck = false;
                    }
                });

                if (itemCheck && this.hashtag !== ''){
                    this.$store.state.register.form.hashtag.push(this.hashtag)
                }
                this.hashtag = '';
            },
            deleteHashtag: function(index) {
                this.$store.state.register.form.hashtag.splice(index, 1);
            }
        }
    }
</script>